export enum UserRole {
  ADMIN_ESTABLISHMENT = 'admin_establishment',

  EMPLOYEE_ESTABLISHMENT = 'employee_establishment',

  MANAGER_ESTABLISHMENT = 'manager_establishment',
}
